import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingWidget } from "./FloatingWidget";
import { universeFromPath } from "@/context/SiteContext";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const universe = universeFromPath(pathname);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div data-universe={universe} className="flex min-h-screen flex-col bg-u-tint">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-50 focus:rounded focus:bg-white focus:px-4 focus:py-2">
        Aller au contenu
      </a>
      <Header universe={universe} />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWidget />
    </div>
  );
}
